import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A9DataUploadTable } from "./table";
import { A9DataUploadEdit } from "./edit";

export default function A9DataUpload() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Chargement de fichiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A9DataUploadEdit />} />
      <Route index element={<A9DataUploadTable />} />
    </Routes>
  );
}
